import { supabase } from "./supabase";

export interface AuthState {
  session: Awaited<ReturnType<typeof supabase.auth.getSession>>["data"]["session"];
  isAdmin: boolean;
  loading: boolean;
}

export async function checkAdmin(userId: string): Promise<boolean> {
  const { data, error } = await supabase
    .from("help_admins")
    .select("user_id")
    .eq("user_id", userId)
    .maybeSingle();
  return !error && !!data;
}

export async function signIn(email: string, password: string) {
  return supabase.auth.signInWithPassword({ email, password });
}

export async function signOut() {
  return supabase.auth.signOut();
}

export async function send2FACode(email: string) {
  return supabase.auth.signInWithOtp({
    email,
    options: { shouldCreateUser: false },
  });
}

export async function verify2FACode(email: string, token: string) {
  return supabase.auth.verifyOtp({ email, token, type: "email" });
}
